<template>
  <div class="room-canvas">
    <div class="d-flex align-items-start p-3">
      <div class="map-legend card">
        <div class="card-body">
          <div class="card-title h5">Legend</div>
          <div class="card-text">
            <div class="d-flex align-items-center">
              <div
                class="map-color rounded border border-dark me-2"
                style="background: #b0e7c4"
              >
                &nbsp;
              </div>
              Available Room
            </div>
            <div class="d-flex align-items-center">
              <div
                class="map-color rounded border border-dark me-2"
                style="background: #e87b86"
              >
                &nbsp;
              </div>
              Unavailable
            </div>
          </div>
        </div>
      </div>
      <div role="toolbar" style="width: fit-content" class="btn-group ms-3">
        <button class="btn btn-outline-secondary" @click.prevent="zoomOut">
          <b-icon-dash />
        </button>
        <button class="btn btn-outline-secondary" @click.prevent="zoomIn">
          <b-icon-plus />
        </button>
      </div>
    </div>
    <div class="canvas-container">
      <div ref="konvaDiv" class="konva-container"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { BIconDash, BIconPlus } from "bootstrap-icons-vue";
import { computed, Ref, ref, toRefs } from "vue";

import { useCanvas } from "./canvas";
import { AbodeFloorDiagram } from "./types";

interface Props {
  floorPlan: AbodeFloorDiagram;
  modelValue?: number | null;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: null,
});

interface Emits {
  (e: "update:modelValue", payload: number | null): void;
}

const emit = defineEmits<Emits>();

const selected = computed({
  get: () => props.modelValue,
  set: (val) => emit("update:modelValue", val),
});
const konvaDiv = ref(null) as unknown as Ref<HTMLDivElement>;

const { floorPlan } = toRefs(props);

const { zoomIn, zoomOut } = useCanvas(floorPlan, selected, konvaDiv);
</script>

<style lang="scss" scoped>
.room-canvas {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #ddd;
  border-left: 0;
}

.konva-container {
  overflow: hidden;
  position: relative;
}

.map-color {
  width: 1rem;
  height: 1rem;
}

.canvas-container {
  flex: 1;
  overflow: hidden;
  padding: 0.25rem;
  position: relative;
}

@media only screen and (min-width: 768px) {
  .room-canvas {
    border-top: 0;
    border-left: 1px solid #ddd;
  }
}
</style>
